/**
 * Community template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import ImageCollageHero from './lib/partials/ImageCollageHero';
import StatsShapesSection from './lib/partials/StatsShapesSection';
import TestimonialsCarousel from './lib/partials/TestimonialsCarousel';
import VideoAndText from './lib/partials/VideoAndText';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Community';

const imageCollageHeroDom = document.querySelector(`[data-image-collage-hero]`);

const statsShapesSectionDom = document.querySelector(`[data-stats-shapes-section]`);

const testimonialsCarouselDom = document.querySelector(`[data-testimonials-carousel]`);

const videoAndTextDoms = document.querySelectorAll(`[data-video-and-text]`);

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initImageCollageHero();
	initStatsShapesSection();
	initTestimonialsCarousel();
	initVideoAndText();
}

/**
 * initImageCollageHero - Initialize the Image Collage Hero component
 */
const initImageCollageHero = () => {
	if (!imageCollageHeroDom) return;

	const imageCollageHero = new ImageCollageHero(imageCollageHeroDom);
	imageCollageHero.init();
}

/**
 * initStatsShapesSection - Initialize the stats shapes section
 */
const initStatsShapesSection = () => {
	Logger.log(`${NAME} > initStatsShapesSection`);

	if (!statsShapesSectionDom) return;

	const el = new StatsShapesSection(statsShapesSectionDom);
	el.init();
}


/**
 * initTestimonialsCarousel - Initialize the testimonials carousel
 */
const initTestimonialsCarousel = () => {
	Logger.log(`${NAME} > initTestimonialsCarousel`);

	if (!testimonialsCarouselDom) return;

	const el = new TestimonialsCarousel(testimonialsCarouselDom);
	el.init();
}

/**
 * initVideoAndText - Initialize the video and text
 */
const initVideoAndText = () => {
	Logger.log(`${NAME} > initVideoAndText`);

	if (!videoAndTextDoms) return;

	videoAndTextDoms.forEach(dom => {
		const el = new VideoAndText(dom);
		el.init();
	});
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
